// extracted by mini-css-extract-plugin
module.exports = {"actionColumnStyle":"BookingsStyles_actionColumnStyle__3HpwD"};